import { RowLayout } from "chorda-bulma";
import { Example } from "../../helpers";
export const MessageExample = () => {
    return RowLayout([
        Example({
            title: 'Basic',
            content: require('./basic').default,
            code: require('!raw-loader!./basic').default
        }),
        Example({
            title: 'Body only',
            content: require('./body-only').default,
            code: require('!raw-loader!./body-only').default
        }),
    ]);
};
